export const getCSRFToken = () => localStorage.getItem("csrfToken");
export const setCSRFToken = (csrfToken: string | null) => {
  if (csrfToken !== null) {
    localStorage.setItem("csrfToken", csrfToken);
  }
};
